// This component is for wrapper of page footer for style purpose and conditional render only
// must be deleted when the actual footer component is updated with the proper style in this component
import React from 'react';
import { View } from 'react-native';

import Footer from '../Footer';

import { ids, styles } from './styles';

type Props = {
  fullWidth?: boolean;
  show?: boolean;
};

const CellRenderrer = ({ fullWidth, show }: Props) => {
  if (!show) return null;
  return (
    <View
      dataSet={{ media: ids.contentWrapper }}
      style={[
        styles.contentWrapper,
        fullWidth ? styles.fullWidthWrapper : styles.maxWidthWrapper,
      ]}
    >
      <Footer />
    </View>
  );
};

export default CellRenderrer;
